(() => {
  const shopHosts = new Set([location.hostname, 'rfricy-tr.myshopify.com', 'shop.motocore.com.tw']);
  const isCommerceUrl = (value) => {
    if (!value) return false;
    try {
      const url = new URL(value, location.href);
      if (!shopHosts.has(url.hostname)) return false;
      return url.pathname.split('/').some((part) => ['cart', 'checkout', 'checkouts'].includes(part.toLowerCase()));
    } catch { return false; }
  };
  const formBlocked = (form) => form instanceof HTMLFormElement && (isCommerceUrl(form.action) || form.querySelector('input[name="form_type"][value="product"]'));
  const clean = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    const nodes = [...root.querySelectorAll('a[href],form,product-form,quick-add-modal,quick-add-bulk,quick-order-list,cart-drawer,cart-notification,.shopify-payment-button,shopify-accelerated-checkout')];
    if (root instanceof Element) nodes.unshift(root);
    for (const node of nodes) {
      if (node instanceof HTMLAnchorElement && isCommerceUrl(node.href) || formBlocked(node) || node.matches('product-form,quick-add-modal,quick-add-bulk,quick-order-list,cart-drawer,cart-notification,.shopify-payment-button,shopify-accelerated-checkout')) node.remove();
    }
  };
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (link && isCommerceUrl(link.href)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', (event) => {
    if (formBlocked(event.target)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  clean(document);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') clean(record.target);
      for (const node of record.addedNodes) clean(node);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'action'] });
})();
